import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { db, auth } from '../firebaseConfig';
import { doc, updateDoc } from 'firebase/firestore';
import './TermsAgreementModal.css';

const RULES = [
  {
    icon: '💰',
    text: 'Streams are virtual tokens with <strong>no real-world monetary value</strong>. They cannot be exchanged for cash directly.',
  },
  {
    icon: '🎁',
    text: 'Earned Streams may be redeemed for gift card rewards (Amazon, Google Play, Visa Prepaid, etc.) subject to withdrawal terms.',
  },
  {
    icon: '🚫',
    text: 'Streams are not currency, cryptocurrency, or a financial instrument of any kind.',
  },
  {
    icon: '👤',
    text: 'You must be <strong>18 years or older</strong> to use StreamStack and request withdrawals.',
  },
  {
    icon: '⚙️',
    text: 'Earn rates and Stream values may change at any time. StreamStack is a rewards program, not a financial product.',
  },
];

export default function TermsAgreementModal({ onDone }) {
  const [agreedTos,     setAgreedTos]     = useState(false);
  const [agreedPrivacy, setAgreedPrivacy] = useState(false);
  const [leaving,       setLeaving]       = useState(false);
  const [loading,       setLoading]       = useState(false);

  const canContinue = agreedTos && agreedPrivacy;

  const handleAgree = async () => {
    if (!canContinue || loading) return;
    setLoading(true);
    try {
      const uid = auth.currentUser?.uid;
      if (uid) {
        await updateDoc(doc(db, 'users', uid), { hasAgreedToTerms: true });
      }
    } catch (_) { /* non-fatal */ }
    setLeaving(true);
    setTimeout(onDone, 350);
  };

  return (
    <div className={`ta-overlay${leaving ? ' ta-overlay--out' : ''}`}>
      <div className={`ta-modal${leaving ? ' ta-modal--out' : ''}`}>

        <div className="ta__header">
          <div className="ta__icon-wrap">📋</div>
          <h2 className="ta__title">Before You Start</h2>
          <p className="ta__subtitle">Please review these key rules and agree to continue.</p>
        </div>

        <div className="ta__rules">
          {RULES.map((rule, i) => (
            <div key={i} className="ta__rule">
              <span className="ta__rule-icon">{rule.icon}</span>
              <p
                className="ta__rule-text"
                dangerouslySetInnerHTML={{ __html: rule.text }}
              />
            </div>
          ))}
        </div>

        <div className="ta__checkboxes">
          <label className="ta__check-row">
            <input
              type="checkbox"
              className="ta__check"
              checked={agreedTos}
              onChange={e => setAgreedTos(e.target.checked)}
            />
            <span className="ta__check-label">
              I have read and agree to the{' '}
              <Link to="/terms" className="ta__link" target="_blank" rel="noopener noreferrer">
                Terms of Service
              </Link>
            </span>
          </label>
          <label className="ta__check-row">
            <input
              type="checkbox"
              className="ta__check"
              checked={agreedPrivacy}
              onChange={e => setAgreedPrivacy(e.target.checked)}
            />
            <span className="ta__check-label">
              I have read and agree to the{' '}
              <Link to="/privacy" className="ta__link" target="_blank" rel="noopener noreferrer">
                Privacy Policy
              </Link>
            </span>
          </label>
        </div>

        <button
          className="btn btn--primary ta__btn"
          onClick={handleAgree}
          disabled={!canContinue || loading}
        >
          {loading ? 'Saving…' : 'I Agree & Continue'}
        </button>

        <p className="ta__footnote">
          By continuing you confirm you are 18 or older and accept these rules.
        </p>
      </div>
    </div>
  );
}
